

import { FunctionComponent, useEffect, useMemo, useRef, useState } from "react";
import { Container, SecaoButao } from "../../../../../components/formulario/styled";
import ModalExportar from "../../../../../components/modalExportar";
import OpenExcelUniversal from "../../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../../components/pdf/DonwloadPdf";
import SearchInput from "../../../../../components/inputs/searchInput";
import ModalIncluir from "../../../../../components/modalIncluir";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../../components/formulario/tableStyled";
import GetSedes from "../../services";
import { Button } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";

interface TabelaMembrosBatismoProps {

}

const TabelaSede: FunctionComponent<TabelaMembrosBatismoProps> = () => {

  const [pesquisaPorMinisterio, setPesquisaPorMinisterio] = useState<string>('');
  const [evento, setEvento] = useState<any>({});

  const router = useNavigate()

  const { listAll, nextPagina, pagina } = GetSedes()

  const devRef = useRef<HTMLElement>(null);

  useMemo(() => {
    listAll?.slice(0, ((pagina + 1) * 30))
  }, [pagina]);

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef])

  const Td = () => <>
    {
      listAll
        .filter(element =>
          String(
            element?.['nomefantasia']).toLocaleLowerCase().normalize('NFD')
            .replace(/[\u0300-\u036f]/g, "")
            .match(
              pesquisaPorMinisterio.toLocaleLowerCase().normalize('NFD')
                .replace(/[\u0300-\u036f]/g, "")
            ) ||
          String(
            element?.['nome']).toLocaleLowerCase().normalize('NFD')
            .replace(/[\u0300-\u036f]/g, "")
            .match(
              pesquisaPorMinisterio.toLocaleLowerCase().normalize('NFD')
                .replace(/[\u0300-\u036f]/g, "")
            )
        )
        .map(
          (element: any) => <tr onClick={() => {router(element?.id + '/edit')}}>
            {
              ['id', 'nomefantasia', 'rua', 'cnpj']?.map(
                des => <td>{element[des]}</td>
              )
            }
            {/* <td>
              <MenuButtonIcons />
            </td> */}
          </tr>)
    }
  </>

  return (<>
    <Outlet/>
    <div style={{ display: "flex", flex: 1, padding: 5 }}>
      <Container>
        <SecaoButao style={{ marginBottom: 5 }}>
          <section style={{ display: 'flex', gap: 5 }}>
            <ModalExportar
              callDownloadExcel={() => OpenExcelUniversal(listAll, ['id', 'nomefantasia'])}
              callDownloadPdf={() => DonwloadPdf(listAll,
                ['Id', 'Descrição'],
                ['id', 'nomefantasia'],
                listAll?.length, [], `${listAll?.length}`)
              }
            />
          </section>
          <SearchInput
            placeholder="Procure pela descrição"
            onChange={(e) => setPesquisaPorMinisterio(e.target.value.replace(/script/g, ""))} />

        <Button
                variant="contained"
                sx={{
                  boxShadow: "none"
                }}
                aria-labelledby="botão-ação-criar-pg"
                onClick={() => router('add')}
              >
                Criar
              </Button>
        </SecaoButao>

        <Tabler>
          {/*@ts-ignore*/}
          <CorpoTable ref={devRef}>
            <Tabela>
              <>
                <TabelaCabeca>
                  <tr>
                    {
                      ['ID', 'Nome', 'Rua', 'CNPJ']?.map(
                        res => <th>{res}</th>
                      )
                    }
                  </tr>
                </TabelaCabeca>
                <TabelaCorpo>
                  <Td />
                </TabelaCorpo>
              </>
            </Tabela>
          </CorpoTable>
        </Tabler>

      </Container>
    </div>
  </>);
}

export default TabelaSede;
